module.exports = __webpack_public_path__ + "static/img/member02.98dca2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member02.png
// module id = 87iS
// module chunks = 0